import { render, staticRenderFns } from "./course.vue?vue&type=template&id=45fd9a21&"
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=45fd9a21&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports